<template>
  <section>
    <THeading
      :level="3"
      tag="h3"
    >
      {{ t('addOns') }}
    </THeading>

    <ul class="grid gap-4 mt-2 sm:grid-cols-2 md:gap-8">
      <li
        v-for="addon in rvListAddOns"
        :key="addon.Id"
      >
        <THeading
          :level="6"
          tag="p"
        >
          {{ getAddonLabelByAddon(addon) }}
        </THeading>

        <TSubHeading v-if="getAddonDescriptionByAddon(addon)">
          {{ getAddonDescriptionByAddon(addon) }}
        </TSubHeading>

        <div class="mt-1">
          <span class="font-semibold">
            {{ getAddonPriceByAddon(addon) }}
          </span>
          <span class="lowercase text-gray-500 text-sm">/{{
            addon.IsDaily ? t('night') : t('trip')
          }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { COUNTRY_SHORTS } from '~/constants'
import type { RvAddon } from '~/types'

const {
  rvLocation,
  rvListAddOns,
} = useRvDetails()

const { priceDisplay } = usePrice()
const { t } = useI18n()

function getAddonLabelByAddon(addon: RvAddon) {
  let label = ''

  if (addon.Slug === 'airport_pickup') {
    label = t('DASHBOARD.ADDONS.AIRPORT_PICKUP')
  }
  else if (addon.Slug && addon.Slug.startsWith('convenience_package')) {
    label = t('DASHBOARD.ADDONS.CONVENIENCE_PACKAGE')
  }
  else if (addon.Slug && addon.Slug.startsWith('custom_package')) {
    label = addon.Name ?? ''
  }
  else {
    label = addon.Name ? t(addon.Name) : addon.Name ?? ''
  }

  return label
}

function getAddonDescriptionByAddon(addon: RvAddon) {
  let description = ''

  if (addon.Slug === 'airport_pickup') {
    description = addon.Name ?? ''
  }
  else if (addon.Slug && addon.Slug.startsWith('convenience_package')) {
    description = addon.Name ?? ''
  }

  return description
}

function getAddonPriceByAddon(addon: RvAddon) {
  return priceDisplay({
    value: addon.PricePerItem,
    countryCode: rvLocation.value?.Country as COUNTRY_SHORTS || COUNTRY_SHORTS.US,
    round: (Number.isInteger(addon.PricePerItem)),
  })
}
</script>

<i18n lang="json">
{
  "en": {
    "addOns": "Add-ons",
    "night": "Night",
    "trip": "Trip"
  },
  "fr": {
    "addOns": "Éléments supplémentaires",
    "night": "Nuit",
    "trip": "Voyage"
  }
}
</i18n>
